import { Box } from 'components/layouts/primitives/Box/Box';
import styled, { css } from 'styled-components';
import { YabbleLogo } from 'components/YabbleLogo/YabbleLogo';
import { borderRadius, borders, colourPalette, padding } from 'styles/styles';
import { Scroller } from 'components/layouts/primitives/Scroller/Scroller';

export const LayoutDashboardLeftMenuButtonStyle = css`
  justify-content: flex-start;
  border-radius: ${borderRadius.roundedMD} !important;
  width: 40px;
  min-width: 40px;

  svg path,
  svg g path {
    stroke: ${colourPalette.neutral400} !important;
  }

  &.is-active,
  &:hover {
    background-color: ${colourPalette.neutral100} !important;
    svg path,
    svg g path {
      stroke: ${colourPalette.neutral600} !important;
    }
  }

  &:active {
    background-color: ${colourPalette.neutral50} !important;
    svg path,
    svg g path {
      stroke: ${colourPalette.neutral400} !important;
    }
  }

  &.is-settings {
    svg path,
    svg g path {
      stroke: ${colourPalette.neutral500} !important;
    }

    &.is-active,
    &:hover {
      background-color: ${colourPalette.neutral100} !important;
      svg path,
      svg g path {
        stroke: ${colourPalette.neutral600} !important;
      }
    }

    &:active {
      background-color: ${colourPalette.neutral50} !important;
      svg path,
      svg g path {
        stroke: ${colourPalette.neutral500} !important;
      }
    }
  }
`;

export const LayoutDashboardLeftMenuStyle = {
  Container: styled(Box)`
    height: 100vh;
    width: 64px;
    overflow: hidden;
    transition: width 0.3s ease-in-out;
    border-right: ${borders.borderSM} solid ${colourPalette.neutral200};
    flex-shrink: 0;

    &.is-settings {
      background-color: ${colourPalette.neutral100};
    }

    .left-menu-content {
      width: 100%;
    }

    .button-icon-custom-wrapper {
      width: 24px !important;
      height: 24px !important;
    }

    .left-menu-item .button-custom-label,
    .left-menu-open-element {
      display: none;
    }

    .left-menu-user {
      padding-left: 4px;
      .button-custom-label {
        display: none;
      }
    }

    .left-menu-customers-dropdown {
      opacity: 0;
      pointer-events: none;
    }

    &.is-open {
      width: 240px;

      &:not(.is-settings) .p-button {
        width: 100%;
      }

      .left-menu-content {
        width: 216px;
      }

      .left-menu-item .button-custom-label,
      .left-menu-open-element {
        display: block;
      }

      .left-menu-closed-element {
        display: none;
      }

      .left-menu-user {
        padding-left: 8px;
        .button-custom-label {
          display: -webkit-box;
        }
      }

      .left-menu-customers-dropdown {
        opacity: 1;
        pointer-events: all;
      }
    }
  `,
  Header: styled(Box)`
    min-height: 56px;
    height: 56px;
    .left-menu-back-button {
      svg path,
      svg g path {
        stroke: ${colourPalette.neutral600} !important;
      }
    }
  `,
  YabbleLogo: styled(YabbleLogo)`
    height: 24px;
  `,
  Scroller: styled(Scroller)`
    scrollbar-gutter: stable both-edges;
    margin: 0 -16px;
    padding: ${padding.paddingXXS} ${padding.paddingLG};
  `,
};
